document.querySelectorAll('.selector-wrapper').forEach(function(e,i){
  e.addEventListener('click',function(ele){
    this.parentElement.classList.toggle('active')
  });
  document.querySelectorAll('[product-select-option]')[i].querySelectorAll('[data-custom-option]').forEach(function(e){
    e.addEventListener('click',function(){
      var targetDiv = this.parentElement.dataset.target,
          mainElement = this.closest('.product-option-wrapper');
      var selecter = document.getElementById(targetDiv);
      selecter.value = this.dataset.value;
      selecter.dispatchEvent(new Event('change'));
      mainElement.classList.remove('active');
      if(mainElement.querySelector('[product-select-option] .sel__box__options.active')){
        mainElement.querySelector('[product-select-option] .sel__box__options.active').classList.remove('active');
      }
      this.querySelector('.sel__box__options').classList.add('active');
    })
  })
})


document.querySelectorAll('.single-option-selector').forEach(function(e){
  document.querySelector(`[data-target="${e.id}"] [data-custom-option][data-value="${e.value}"]`).click();
})



$('.sidebar_scroll_link ul li a, .back_to_top a').click(function(e){
  e.preventDefault();
  $('html, body').animate({
    scrollTop: $( $(this).attr('href') ).offset().top - 110
  }, 500);
  return false;
});



var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}